<template>
  <div class="login_wrap" >
    <div class="bg" >
<!--      <img src="./img/logo1.png" />-->
      <div class="title_text" >中科华康</div>
    </div>

    <div class="form_wrap" >
      <van-form @submit="onSubmit">
        <div class="form_item_wrap" >
          <div>手机号</div>
          <div class="input_wrap" >
            <van-field
              placeholder="请输入手机号"
              :maxlength="11"
              name="phone"
              :border="false"
              type="number"
              v-model="phone"
              class="form_input"
              :rules="[{ required: true, message: '' }]"
            />
          </div>
        </div>

        <div class="form_item_wrap" >
          <div>验证码</div>
          <div class="input_wrap" >
            <van-field
              placeholder="请输入验证码"
              :maxlength="6"
              :border="false"
              name="verificationCode"
              class="form_input"
              v-model="verificationCode"
              type="number"
              :rules="[{ required: true, message: '' }]"
            >
              <template #button>
                <div class="send" @click="getCode" >{{ second > 0 ? second+'秒后重新获取': '发送验证码' }}</div>
              </template>
            </van-field>
          </div>
        </div>

        <van-button round block type="info" class="submit" native-type="submit" :loading="submitting" >登录</van-button>
      </van-form>
    </div>

  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  sendLoginVerificationCode,
  getUserInfo,
  loginByTel
} from '@/api/login'
import { Toast } from 'vant'
export default {
  name: 'login',
  data() {
    return {
      second: 0,
      submitting: false,
      verificationCode: '',
      phone: '',
      fromName: '',
      token:'',
    }
  },
  methods:{
    onSubmit(values) {
      this.submitting = true
      loginByTel({...values}).then(res => {
        console.log('res:', res)
        this.submitting = false
        if(res.success) {
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('userVo', JSON.stringify(res.data.userVo))
          this.$router.push({ name: this.fromName ? this.fromName : 'home' })
          window.location.reload()
        }else {
          Toast(res.msg)
        }
      })
      /*localStorage.setItem('token', 'b20bb85bcdfe272e2f66eca3ad6a09cd')
      localStorage.setItem('userVo', {"createTime":"2021-12-18","headImgUrl":"https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83epNibTuRPEUkxYibjLw88t0jVGIuL66mAGcZUa304sYbfziaEjTP1lXX5DW8atKy93F2Bia8JnxnJdpRg/132","level":"-1","nickName":"undefined","parentNickName":"","tel":"132****2265","type":"1","upLevelTime":"","userId":"1472081171495129089"})
      this.$router.push({ name: this.fromName ? this.fromName : 'home' })*/
    },
    getCode() {
      const { phone } = this
      if(!phone) {
        Toast('请输入手机号')
        return false
      }

      if(this.second > 0) {
        return false
      }

      sendLoginVerificationCode({  phone }).then(res => {
        if(res.success) {
          this.second = 60
          let timer = setInterval(() => {
            this.second --;
            if(this.second <=0) {
              clearInterval(timer)
            }
          }, 1000)
        }else {
          Toast(res.msg)
        }
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromName = from.name
    })
  },
  mounted(options) {
    const url = new URL(window.location.href);
    const token = url.searchParams.get('token'); // "John"
    if (token && token.length != 0){
      localStorage.setItem('token', token)
      this.$router.push({ name: this.fromName ? this.fromName : 'home' })
      window.location.reload()
    }else{
      if(localStorage.getItem('token')) {
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>
